<template>
    <b-container>
        <Breadcrumbs crumbString="View Our Work"></Breadcrumbs>
        <b-row>
            <b-col class="col-12 col-md-4 col-lg-4">
                <h2>{{ title }}</h2>
                <div>
                    enviroSIGNS has developed a wide variety of projects across the United States and beyond.
                    We have worked with federal, state, city, and local entities. Our clients include public resource
                    agencies, historical groups, private enterprise organizations, contractors, and many others.
                  <ul>
                    <li><router-link :to="{ name: 'mtvernon' }">Mt. Vernon</router-link></li>
                    <li><router-link :to="{ name: 'highway12' }">Highway 12</router-link></li>
                    <li><router-link :to="{ name: 'jordanriver' }">Jordan River</router-link></li>
                    <li><router-link :to="{ name: 'logancity' }">Logan City</router-link></li>
                    <li><router-link :to="{ name: 'oregon' }">Oregon Islands NWR</router-link></li>
                    <li><router-link :to="{ name: 'lapetiteroche' }">La Petite Roche</router-link></li>
                    <li><router-link :to="{ name: 'smithfarm' }">Smith Farm</router-link></li>
                    <li><router-link :to="{ name: 'williamsons' }">Williamson's Battlefield</router-link></li>
                    <li><router-link :to="{ name: 'watershed' }">SLC Watershed</router-link></li>
                    <li><router-link :to="{ name: 'seeforever' }">See Forever Village</router-link></li>
                  </ul>
                </div>
            </b-col>
            <b-col class="col-12 col-md-8">
                <b-container class="pods-container">
                    <b-row>
                        <b-col class="col-12 col-md-7">
                            <b-row>
                                <b-col>
                                    <b-row>
                                        <b-col class="col-12 col-md-12 image-pod">
                                          <router-link :to="{ name: 'mtvernon' }">
                                            <div class="img vow-img-178"
                                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/interactive-interpretive-signs.jpg') + ')'}"></div>
                                            <span>Mt. Vernon</span>
                                          </router-link>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col class="col-12 col-md-12 image-pod">
                                          <router-link :to="{ name: 'highway12' }">
                                            <div class="img vow-img-136"
                                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/interpretive-waysides.jpg') + ')'}"></div>
                                            <span>Highway 12</span>
                                          </router-link>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col class="col-12 col-md-5 image-pod">
                                  <router-link :to="{ name: 'jordanriver' }">
                                    <div class="img vow-img-324"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/imageLOC-wayfinding-signs.jpg') + ')'}"></div>
                                    <span>Jordan River</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12 col-md-4 image-pod">
                                  <router-link :to="{ name: 'logancity' }">
                                    <div class="img vow-img-1781"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/logan-city.jpg') + ')'}"></div>
                                    <span>Logan City</span>
                                  </router-link>
                                </b-col>
                                <b-col class="col-12 col-md-8 image-pod">
                                  <router-link :to="{ name: 'oregon' }">
                                    <div class="img vow-img-1781"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/high-pressure-laminate-wayside-exhibits.jpg') + ')'}"></div>
                                    <span>Oregon Islands NWR</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="col-12 col-md-5">
                            <b-row>
                                <b-col class="col-12 image-pod">
                                  <router-link :to="{ name: 'lapetiteroche' }">
                                    <div class="img vow-img-178"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/novalloy-historical-signs.jpg') + ')'}"></div>
                                    <span>La Petite Roche</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col class="col-12 image-pod">
                                  <router-link :to="{ name: 'smithfarm' }">
                                    <div class="img vow-img-3242"
                                         v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/novalloy-interpretive-exhibits.jpg') + ')'}"></div>
                                    <span>Smith Farm</span>
                                  </router-link>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-12 col-md-5 image-pod">
                          <router-link :to="{ name: 'williamsons' }">
                            <div class="img vow-img-200"
                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/NPS-wayside-exhibits.jpg') + ')'}"></div>
                            <span>Williamson's Battlefield</span>
                          </router-link>
                        </b-col>
                        <b-col class="col-12 col-md-2 image-pod">
                          <router-link :to="{ name: 'watershed' }">
                            <div class="img vow-img-200"
                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/upright-interpretive-signs.jpg') + ')'}"></div>
                            <span>SLC Watershed</span>
                          </router-link>
                        </b-col>
                        <b-col class="col-12 col-md-5 image-pod">
                          <router-link :to="{ name: 'seeforever' }">
                            <div class="img vow-img-200"
                                 v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/view-our-work/corten-steel-wayfinding-signs.jpg') + ')'}"></div>
                            <span>See Forever Village</span>
                          </router-link>
                        </b-col>
                    </b-row>
                </b-container>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  import Breadcrumbs from '../Breadcrumbs.vue'

  export default {
    components: {
      Breadcrumbs
    },

    data () {
      return {
        title: 'View Our Work'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/ViewOurWork.vue